//React
import React from "react";
import {
  Link
} from "react-router-dom";
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as myProfileAction from '../action/myProfileAction';
import * as uiAction from '../action/uiAction';
import * as actionLogAction from '../action/actionLogAction';
//Material-ui
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Box from '@material-ui/core/Box';
import Checkbox from '@material-ui/core/Checkbox';
//Add
import axios from 'axios';
import config from '../config';
import Cookies from 'js-cookie';
import moment from 'moment';
import { scroller, Element } from 'react-scroll';
import { imageResize } from '../func/imageResizeRotate';
//Part
import PartDropZone from './PartDropZone';

//Icon
import AddAPhotoIcon from '@material-ui/icons/AddAPhoto';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';


//Dialog
import DialogConfirm from './DialogConfirm';

//JSON
var bankPlanItem = require('../data/bankPlanItem');
var rubyItem = require('../data/rubyItem');

class Comp extends React.Component {
  constructor(props) {
		super(props);

    this.state = {
      price: null,
      days: null,
      chargeBankId: '',
      chargeBankIdRuby: '',
      inputChargeBankId: '',
      inputChargeBankImg: null,
      inputChargeBankImgVisiable: false,
      submitDialogVisiable: false,
      noProofPerson: false,
    }
	}

  componentDidMount() {
    let birthdayDay = this.props.my.profile.userdata_birthday.slice(-4);
    let chargeBankId = (this.props.auth.ui + birthdayDay);

    let chargeBankIdRuby = chargeBankId.split('').map(function(value) {
      let index = rubyItem.findIndex((v) => v.en === value);
      if (index > -1) {
        return rubyItem[index].ja;
      }
      else {
        return null;
      }
    });
    this.setState({
      chargeBankId: chargeBankId,
      chargeBankIdRuby: chargeBankIdRuby.join(" "),
      inputChargeBankId: chargeBankId,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.days && prevState.days !== this.state.days) {
      console.log('BANK');
      this.props.actionLogAdd('銀行', this.state.days);
    }
  }

  _select(days, price) {
    if (this.props.my.proof.person !== 1) {
      this.setState({noProofPerson: true });
    }
    else {
      this.setState({days: days, price: price, });
      scroller.scrollTo('submit_block', {
        delay: 300,
        duration: 300,
        smooth: true,
        offset: -50,
      })
    }
  }

  async _imageLoad(file) {
    await imageResize(file, 800).then((res) => {
      this.setState({inputChargeBankImg:res.uri});
    }).catch((err) => {
      this.setState({inputChargeBankImg:null});
      this.props.snackOpen('error', err.comment , 5000)
    })
  }

  _submit() {
    var params = new URLSearchParams();
    var contactText = '振り込み人名:' + this.state.inputChargeBankId;
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('contactSubject', '銀行振込の確認依頼-' + this.state.inputChargeBankId);
    params.append('contactEmail', 'support@partner-s.net');
    params.append('contactText', contactText);
    if (this.state.inputChargeBankImg) {
      params.append('contactPhotoBase64', this.state.inputChargeBankImg);
    }
    return axios.post(config.apiUri + "contactApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      if(res.data.bool) {
        this.setState({
          submitDialogVisiable: false,
          inputChargeBankImg: null,
          inputChargeBankImgVisiable: false,
        });
        this.props.snackOpen('success', '送信しました。お振り込み情報を確認し、有料サービスを開始させていただきます。開始まで今しばらくお待ちください。', 10000);
      }
    })
    .catch((err) => {
      alert( config.apiErrComment );
    })
  }

  render() {
    let startDate = moment.unix(this.props.my.setting.chargeStart);
    let endDate =  moment.unix(this.props.my.setting.chargeEnd);
    let nowDate =  moment();


    return (
      <div>
        <div style={{padding:'10px'}}>
          <h2 align='center'>お近くのATMからお振込みいただけます</h2>

          <div style={{padding:'10px'}}>
            銀行、コンビニ等のATMからお振込みいただけます。<br />
            土日祝日でもお振込み明細の画像を送信いただくとその日から有料サービスを開始できます。
            <div style={{fontSize:'0.8em',color:'#666'}}>
              カスタマーサポートの営業時間外の場合、有料サービスの開始までお時間がかかる場合がございます。
              お急ぎの場合は、クレジット決済やビットキャッシュをご検討ください。
            </div>
          </div>
        </div>

        <div style={{padding:'10px'}}>
          <h2 align='center'>プランを選択してください</h2>
          {
            (nowDate.isBetween(startDate , endDate) === true) && (
              <div style={{padding:'10px'}}>お客様のアカウントは有料サービス中の為、有料サービスの終了日はプランの日数分延長されます。</div>
            )
          }

          <div style={{maxWidth:'400px', margin:'auto'}}>
            {
              bankPlanItem.map( (value, index) => {

                let checked;
                if (this.state.days === value.days) {
                  checked = true;
                }
                else {
                  checked = false;
                }

                let borderColor;
                let textColor;
                let iconType;
                if (index === 0) {
                  borderColor = '#FFE7C2';
                  textColor = '#FF9900';
                  iconType = 'orange_icon';
                }
                else if (index === 1) {
                  borderColor = '#A6BDD5';
                  textColor = '#0D58A6';
                  iconType = 'blue_icon';
                }
                else if (index === 2) {
                  borderColor = '#E7B0D0';
                  textColor = '#CB0077';
                  iconType = 'red_icon';
                }

                let startDate = moment.unix(this.props.my.setting.chargeStart);
                let endDate =  moment.unix(this.props.my.setting.chargeEnd);
                let nowDate =  moment();
                let newEndDateComp;

                if (nowDate.isBetween(startDate , endDate )) {
                  newEndDateComp = (
                    <div style={{marginTop:'5px'}}>
                      <div style={{fontSize:'0.9em', color:'#666'}}>有料サービス</div>
                      <div style={{fontSize:'1.1em', color:'#333'}}>
                        { endDate.add(value.days, 'days').format('YYYY年MM月DD日') }まで
                      </div>
                    </div>
                  )
                }
                else {
                  newEndDateComp = (
                    <div style={{marginTop:'5px'}}>
                      <div style={{fontSize:'0.9em', color:'#666'}}>有料サービス</div>
                      <div style={{fontSize:'1.1em', color:'#333'}}>
                          有料サービス { nowDate.add((value.days - 1), 'days').format('YYYY年MM月DD日') }まで
                      </div>
                    </div>
                  )
                }

                return (
                  <div key={index}>
                    <Box className='button_chargePlan round12' boxShadow={3}
                      style={{
                        color: '#333',
                        borderTop: 'solid 6px ' + borderColor,
                        margin: '15px',
                        cursor: 'pointer',
                      }}
                      onClick={ () => this._select(value.days, value.price) }
                    >
                      <div style={{padding:'15px'}}>
                        <div
                          style={{
                            display:'flex',
                            alignItems:'center',
                            justifyContent:'space-between',
                          }}
                        >
                          <div style={{fontSize:'1.4em', fontWeight:500, color:textColor}}>{ value.ja }</div>
                          <div>
                            <Checkbox
                              checked={checked}
                              style ={{color: textColor}}
                            />
                          </div>
                        </div>
                        <div>
                          <div
                            style={{
                              display:'flex',
                              flexDirection:'row',
                              alignItems:'center',
                              justifyContent:'space-between',
                            }}
                          >
                            <div>
                              <span style={{fontSize:'1.8em', fontWeight:'bold', color:textColor}}>¥{ value.price }</span>
                              <span style={{fontSize:'1em', color:textColor}}>(税込)</span>
                            </div>

                            {
                              (value.discount > 0) && (
                                <div><span className={iconType}>¥{value.discount}お得</span></div>
                              )
                            }
                          </div>
                        </div>
                        {
                          (value.discount > 0) && (
                            <div>30日換算で¥{ value.convert }</div>
                          )
                        }
                        {
                          newEndDateComp
                        }
                      </div>
                    </Box>
                  </div>
                )
              })
            }
          </div>
        </div>

        <Element name='submit_block'>
          {
            (this.state.days) && (
              <div>

                <div align='center'>
                  <ArrowDropDownIcon style={{color:'#ccc',fontSize:'4em'}}/>
                </div>

                <div style={{margin:'0px 3%'}}>
                  <h2 align='center'> お振り込み先 </h2>
                  <table className='chargeBankTable'>
                    <tbody>
                      <tr>
                        <td className='title'><div className='text'>銀行名</div></td>
                        <td className='value'>GMOあおぞらネット銀行</td>
                      </tr>
                      <tr>
                        <td className='title'><div className='text'>支店名</div></td>
                        <td className='value'>法人営業部 (101)</td>
                      </tr>
                      <tr>
                        <td className='title'><div className='text'>種別</div></td>
                        <td className='value'>普通</td>
                      </tr>
                      <tr>
                        <td className='title'><div className='text'>口座番号</div></td>
                        <td className='value'>1178161</td>
                      </tr>
                      <tr>
                        <td className='title'><div className='text'>受取人名</div></td>
                        <td className='value'>
                          カ）パートナーズ
                          <div style={{fontSize:'0.8em',color:'red'}}>「カ）」が未入力の場合、お振込み失敗となりますのでご注意ください</div>
                        </td>
                      </tr>
                      <tr>
                        <td className='title'><div className='text'>金額</div></td>
                        <td className='value'>
                          { this.state.price }円(税込)
                          <div style={{fontSize:'0.8em',color:'#666'}}>振り込み手数料はお客様のご負担でお願いいたします</div>
                        </td>
                      </tr>
                      <tr>
                        <td className='title'><div className='text'>お振込み人名</div></td>
                        <td className='value'>
                          <div style={{fontSize:'0.7em',color:'#666'}}>{ this.state.chargeBankIdRuby }</div>
                          <div>{ this.state.chargeBankId }</div>
                          <div style={{fontSize:'0.8em',color:'#666'}}>お客様のアカウントを特定する数字です</div>
                          <div style={{fontSize:'0.8em',color:'red'}}>
                            異なる名前でお振込みの場合、有料サービスを開始できない場合があります。下記のフォームからお振込み人名をサポートまでお知らせください
                          </div>
                        </td>
                      </tr>

                    </tbody>
                  </table>
                </div>

                <div align='center'>
                  <ArrowDropDownIcon style={{color:'#ccc',fontSize:'4em'}}/>
                </div>

                <div style={{margin:'2%', padding:'15px'}}>
                  <h2 align='center'>
                    <span className='i-b'>お振込が完了したら</span>
                    <span className='i-b'>送信してください</span>
                  </h2>
                  銀行の営業時間内でご入金が確認できる場合、ご入金の確認後に有料サービスの開始のお手続きを開始させていただいております。

                  <div style={{padding:'5px'}} align='center'>
                    <h3 align='center'> お振込み人名が異なる場合は編集してください </h3>
                    <input
                      type="text"
                      value={ this.state.inputChargeBankId }
                      style={{fontSize:'1.2em',maxWidth:'300px'}}
                      className="input_blue round12"
                      onChange={ (e) => this.setState({inputChargeBankId: e.target.value}) }
                    />
                  </div>

                  <div align='center' style={{padding:'5px'}}>
                    <Button
                      variant="outlined"
                      color='primary'
                      onClick={ () => this.setState({inputChargeBankImgVisiable: (this.state.inputChargeBankImgVisiable) ? false : true}) }
                      style={{fontSize:'1em'}}
                    >
                      銀行営業時間外の場合
                    </Button>
                  </div>

                  {
                    (this.state.inputChargeBankImgVisiable) && (
                      <div style={{margin:'10px'}}>
                        <h3 align='center'>
                          振り込み明細の画像
                        </h3>
                        <div>
                          振り込み先、振り込み人名、振り込み金額、日時の確認できる、銀行振込み明細の画像か、ネットバンクの振込み完了画面を撮影して送ってください。<br/>
                        </div>

                        <PartDropZone
                          handleDrop={ (e) => this._imageLoad(e) }
                          style={{position:'relative'}}
                        >


                          {
                            (this.state.inputChargeBankImg) ?
                            <label htmlFor="photo_file" style={{cursor:"pointer"}}>
                              <div style={{textAlign:'center', margin:'5px', position:'relative', minHeight:'50px'}}>
                                <div align='center' style={{padding:'5px', position:'relative'}}>
                                    <img style={{ maxWidth:'240px' }} src={this.state.inputChargeBankImg} id='thumb' alt='' />
                                </div>
                              </div>
                            </label>
                            :
                            <div>
                              <div align='center' style={{padding:'5px'}}>
                                <label htmlFor="photo_file" style={{display:'block'}}>
                                  <IconButton component="span">
                                    <AddAPhotoIcon style={{fontSize:'4em'}}/>
                                  </IconButton>
                                </label>

                                <label htmlFor="photo_file" style={{cursor:"pointer", display:'block'}}>
                                  <Button variant="outlined" component="span">
                                    画像を選択してください
                                  </Button>
                                </label>
                              </div>
                            </div>
                          }
                        </PartDropZone>
                        <div align='center'>
                          <input
                            type='file'
                            id='photo_file'
                            accept='image/*'
                            onChange={ (e) => {
                              this._imageLoad(e.target.files[0]);
                              e.target.value = null;
                            }}
                            style={{opacity:'0'}}
                          />
                        </div>
                      </div>
                    )
                  }




                  <div align='center' style={{padding:'5px'}}>
                    <Button
                      variant="contained"
                      color='primary'
                      onClick={ () => this.setState({submitDialogVisiable: true}) }
                      style={{fontSize:'1.2em'}}
                    >
                      振り込み完了を送信
                    </Button>
                  </div>
                </div>



                <DialogConfirm
                  open={ this.state.submitDialogVisiable }
                  title={'振込完了を送信しますか？'}
                  content={'お振込みを確認いたします。お振込み人名は「'+ this.state.inputChargeBankId +'」でよろしいですか？'}
                  apply={ () => this._submit() }
                  close={ () => this.setState({submitDialogVisiable: false}) }
                />

              </div>
            )
          }
        </Element>
        <div style={{padding:'5px'}}>

          <div style={{padding:'10px',fontSize:'0.9em',color:'#666'}}>
            ※ 提供サービスの性質上、クーリングオフの適応はありません。<br/>
            また有料サービスの期間中に退会された場合も日割り計算による料金の払い戻しはありません。
          </div>

        </div>
        <DialogConfirm
          open={ this.state.noProofPerson }
          title={'本人証明が未提出'}
          content={(
            <div>
              <h2 align='center'>有料サービスのお申し込みには<br/>本人証明が必要です</h2>
              <div align='center' style={{padding:'10px'}}>
                <Link to='/my/proof/person'>
                  <Button
                    variant="contained"
                    color='primary'
                  >
                    本人証明を申請する
                  </Button>
                </Link>
              </div>
            </div>
          )}
          close={ () => this.setState({noProofPerson: false}) }
        />
      </div>
    )

  }
}


const mapStateToProps = (state) => {
	return {
    auth: state.auth,
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...myProfileAction,
    ...uiAction,
    ...actionLogAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
